import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                // { name: 'Layouts', route: 'layouts', type: 'layout', },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
                { name: 'Notifications', route: 'notifications', type: 'notification' },
            ],
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Products',
            route: 'products',
            type: 'product',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.PackageIcon,
        },
        {
            name: 'Categories',
            route: 'categories',
            type: 'category',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.TagIcon,
        },
        {
            name: 'Nav Categories',
            route: 'nav_categories',
            type: 'nav_category',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.DatabaseIcon,
        },
        // {
        //     name: 'Concerns',
        //     route: 'concerns',
        //     type: 'concern',
        //     color: 'navy',
        //     group: 'Catalogue',
        //     iconComponent: FeatherIcons.AlertCircleIcon,
        // },
        // {
        //     name: 'Brands',
        //     route: 'brands',
        //     type: 'brand',
        //     color: 'navy',
        //     group: 'Catalogue',
        //     iconComponent: FeatherIcons.BookmarkIcon,
        // },
        {
            name: 'Bundles',
            route: 'bundles',
            type: 'bundle',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.ArchiveIcon,
        },
        // {
        //     name: 'Product Attributes',
        //     route: 'product_attributes',
        //     type: 'product_attribute',
        //     color: 'navy',
        //     group: 'Catalogue',
        //     iconComponent: FeatherIcons.AtSignIcon,
        // },
        // {
        //     name: 'Discount Codes',
        //     route: 'discount_codes',
        //     type: 'discount_code',
        //     color: 'navy',
        //     group: 'Catalogue',
        //     iconComponent: FeatherIcons.DollarSignIcon,
        // },
        // {
        //     name: 'Product Reviews',
        //     route: 'product_reviews',
        //     type: 'product_review',
        //     color: 'navy',
        //     group: 'Catalogue',
        //     iconComponent: FeatherIcons.StarIcon,
        // },
        {
            name: 'Blog',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        /* {
            group: 'media',
            name: 'Videos',
            type: 'video',
            route: 'videos',
            // iconClass: 'material-icons',
            iconName: 'video',
            color: 'navy',
            iconComponent: FeatherIcons.UsersIcon,
        },*/

        // {
        //     name: 'Campaigns',
        //     route: 'campaigns',
        //     type: 'campaign',
        //     color: 'navy',
        //     group: 'media',
        //     iconComponent: FeatherIcons.SendIcon,
        // },
        {
            group: 'Team',
            name: 'Team',
            type: 'staff_member',
            route: 'staff_members',
            iconClass: 'material-icons',
            iconName: 'sentiment_satisfied_alt',
            color: 'navy',
            iconComponent: FeatherIcons.UsersIcon,
        },

        {
            name: 'Customers',
            route: 'customers',
            type: 'customer',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.UsersIcon,
        },
        {
            name: 'Orders',
            route: 'orders',
            type: 'order',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Enquiries',
            type: 'enquiry',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MailIcon,
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
